import React from 'react';
import { useSelector } from 'react-redux';
import { ContentLoader } from '@dev/ee-components';
import styled from 'styled-components';

import { getContactsStore } from '@/store/contacts/actions';
import { AnalyticsGraph } from './AnalyticsGraph';

const AnalyticsGraphContainer = styled.div`
    width: 68%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-content: center;
`;

export const AnalyticsGraphSection = (): JSX.Element => {
    const { validationStatus } = useSelector(getContactsStore);
    return (
        <AnalyticsGraphContainer>
            {validationStatus?.ValidationStatus ? (
                <AnalyticsGraph />
            ) : (
                <div style={{ textAlign: 'center' }}>
                    <ContentLoader mode="circle" width={450} height={450} />
                </div>
            )}
        </AnalyticsGraphContainer>
    );
};